import React, { useState } from 'react';
import { Button, Typography, TextField } from '@material-ui/core';
import styled from 'styled-components';
import parse from 'html-react-parser';
import * as Scroll from 'react-scroll';
import { useSnackbar } from 'notistack';
import { postFormApp } from '../../services';
import { Icons } from '../../components';

const Element = Scroll.Element;
const scroller = Scroll.scroller;

const StyledWrap = styled.div`
  display: flex;
  justify-content: center;
`;

const StyledWrapContent = styled.div`
  width: 100%;
  max-width: 900px;
  display: flex;
  flex-direction: column;
`;

const StyledHeader = styled.div`
  display: flex;
  padding: 16px;
  border-bottom: 1px solid #d4d4d4;
`;

const StyledIcon = styled.div`
  cursor: pointer;
  padding-top: 5px;
`;

const StyledTitle = styled.div`
  margin-left: 24px;
  display: flex;
  flex: 1;
  flex-direction: column;
`;

const StyledButton = styled.div`
  display: flex;
  align-items: center;
`;

const StyledBody = styled.div`
  padding-bottom: 32px;
  border-bottom: 1px solid #d4d4d4;
`;

const StyledForm = styled.form`
  @media screen and (min-width: 500px) {
    max-width: 70%;
  }
  margin-top: 8px;
  padding: 24px;
`;

const initForm = {
  id: '',
  id_content: '',
  fullname: '',
  email: '',
  cv: '',
  hp: '',
};

const DetailLoker = ({ isId, onHandleBack, dataLoker }: any) => {
  const { enqueueSnackbar } = useSnackbar();
  const [formState, setFormState] = useState(initForm);
  const [applyNowState, setApplyNowState] = useState(false);
  const {
    sub_title_id,
    sub_title_en,
    place,
    contract,
    content_id,
    content_en,
  } = dataLoker;
  const subTitle = `${place} | ${contract}`;

  const handleAddPelamar = async (e: any) => {
    e.preventDefault();
    const body = new FormData();
    body.append('cv', formState.cv);
    body.append('id_content', dataLoker.id);
    body.append('fullname', formState.fullname);
    body.append('email', formState.email);
    body.append('hp', formState.hp);
    body.append('type_form', '1');
    try {
      const res = await postFormApp(body);
      if (res.status === 'error') {
        enqueueSnackbar(res.message, {
          variant: 'error',
        });
        return;
      }
      enqueueSnackbar(`Berhasil mengirimkan data`, {
        variant: 'success',
      });
      setFormState(initForm);
    } catch (err) {
      enqueueSnackbar(err.message, {
        variant: 'error',
      });
    }
  };

  const handleChange = (event: any) => {
    if (event.target.name === 'cv') {
      setFormState({ ...formState, cv: event.target.files[0] });
    } else {
      setFormState({ ...formState, [event.target.name]: event.target.value });
    }
  };

  return (
    <StyledWrap>
      <StyledWrapContent>
        <StyledHeader>
          <StyledIcon onClick={onHandleBack}>
            <Icons.IconBack height={25} width={25} />
          </StyledIcon>
          <StyledTitle>
            <Typography variant='h5' color='primary'>
              {isId ? sub_title_id : sub_title_en}
            </Typography>
            <Typography color='textPrimary'>{subTitle}</Typography>
          </StyledTitle>
          <StyledButton>
            <Button
              variant='contained'
              color='primary'
              disabled={applyNowState}
              onClick={() => {
                setApplyNowState(true);
                scroller.scrollTo('form-karir', {
                  smooth: true,
                  duration: 500,
                });
              }}
            >
              {isId ? 'Daftar Sekarang' : 'Apply Now'}
            </Button>
          </StyledButton>
        </StyledHeader>
        <StyledBody>
          <div id='content' style={{ marginTop: '2rem' }}>
            {parse(isId ? content_id : content_en)}
          </div>
        </StyledBody>
        <Element name='form-karir'>
          {applyNowState && (
            <StyledForm onSubmit={handleAddPelamar}>
              <Typography
                variant='h5'
                color='primary'
                style={{ marginBottom: '2rem' }}
              >
                {isId ? 'Kirimkan Lamaranmu' : 'Submit Your Application'}
              </Typography>
              <TextField
                onChange={handleChange}
                value={formState.fullname}
                name='fullname'
                label={isId ? 'Nama Lengkap' : 'Fullname'}
                variant='outlined'
                fullWidth
                required
                style={{ marginBottom: '1rem' }}
              />
              <TextField
                onChange={handleChange}
                value={formState.email}
                type='email'
                name='email'
                label='Email'
                variant='outlined'
                fullWidth
                required
                style={{ marginBottom: '1rem' }}
              />
              <TextField
                onChange={handleChange}
                value={formState.hp}
                type='number'
                name='hp'
                label='No.Handphone'
                variant='outlined'
                fullWidth
                required
                style={{ marginBottom: '1rem' }}
              />
              <Typography color='textPrimary'>Upload CV (max. 5mb)</Typography>
              <TextField
                onChange={handleChange}
                type='file'
                name='cv'
                variant='outlined'
                fullWidth
                required
                style={{ marginBottom: '2rem' }}
              />
              <Button variant='contained' color='primary' type='submit'>
                {isId ? 'Kirim' : 'Send'}
              </Button>
            </StyledForm>
          )}
        </Element>
      </StyledWrapContent>
    </StyledWrap>
  );
};

export default DetailLoker;
